// API PATHS
export const API_TEST_CASE_PATH = 'testcases';
export const API_MODULES_PATH = 'modules';
export const API_SCHEMES_PATH = 'schemes';
export const API_FAVORITES_PATH = 'favorites';
export const API_FILES_PATH = 'files';
export const API_TAGS_PATH = 'tags';
export const API_TOKEN_PATH = 'token';
export const API_HISTORY_PATH = 'history';
export const API_STANDS_PATH = 'stands';
export const API_USERS_PATH = 'users';
export const API_USER_PATH = 'user';
export const API_TEST_PLAN_PATH = 'testplans';
export const API_TEST_RUN_PATH = 'testruns';
export const API_TEST_RESULTS_PATH = 'testresults';
export const API_HAND_TEST_RESULTS_PATH = 'handtestresults';
export const API_AUTO_TEST_RESULTS_PATH = 'autotestresults';
export const API_DASHBOARD_PATH = 'dash';
export const API_VSPHERE_PATH = 'vsphere';
export const API_GENERATOR_PATH = 'generator';
export const API_RULE_SET_PATH = 'ruleset';
export const API_BUILDS = 'builds';
export const API_BRANCHES = 'branches';
export const API_VERSIONS = 'versions';
export const API_PERFORMANCE_PATH = 'perf';
export const API_DASHBOARD_DEVICES_PATH = 'devices';
export const API_BOOKING_DEVICES_PATH = 'devices';
export const API_PCAP_FILES_PATH = 'pcaps';
export const API_BOOKING_PATH = 'hardware/booking';
export const API_DATASHEETS_PATH = 'datasheets';
export const API_DATASHEETS_TEST_REPORT_EXPORT_PATH = 'test-report';
export const API_JOB_PATH = 'job';
export const API_TEAMS_PATH = 'teams';
export const API_DEFECTS_PATH = 'defects';

// UI PATHS
export const UI_FUNCTIONAL_TESTING_PATH = 'functional';
export const UI_PERFORMANCE_TESTING_PATH = 'performance';
export const UI_TEST_CASE_PATH = 'testcases';
export const UI_MODULES_PATH = 'modules';
export const UI_SCHEMES_PATH = 'schemes';
export const UI_STANDS_PATH = 'stands';
export const UI_FAQ_PATH = 'faq';
export const UI_PROFILE_PATH = 'profile';
export const UI_TEST_PLAN_PATH = 'testplans';
export const UI_TEST_RUN_PATH = 'testruns';
export const UI_TEST_RESULTS_PATH = 'testresults';
export const UI_HAND_TEST_RESULTS_PATH = 'handtestresults';
export const UI_AUTO_TEST_RESULTS_PATH = 'autotestresults';
export const UI_PERFORMANCE_PATH = 'performance';
export const UI_DASHBOARDS_PATH = 'dashboards';
export const UI_EXECUTION_PATH = 'execution';
export const UI_GENERATOR_PATH = 'generator';
export const UI_RULESET_PATH = 'rulesets';
export const UI_GENERATOR_PROFILE_PATH = 'profiles';
export const UI_HISTORY_PATH = 'history';
export const UI_LIBRARY_PATH = 'library';
export const UI_BOOKING_PATH = 'booking';
export const UI_DATASHEETS_PATH = 'datasheets';
export const UI_DATASHEETS_TABLE_PATH = 'table';
export const UI_DATASHEETS_CHARTS_PATH = 'charts';
export const UI_DEFECTS_PATH = 'defects';
